import React from "react";
import firstImage from "../assets/images/Main-banner-image.png";
import googlePlayStore from "../assets/images/Google-Play-Store.png";
import applerPlayStore from "../assets/images/Apple-Play-Store.png";

const firstPage = () => {
  return (
    <>
      <div className="container mx-auto flex flex-col items-center text-center sm:flex-row sm:justify-between px-2 py-8 md:py-0 mt-[70px] sm:mt-[50px] lg:mt-[10px] mainbanner-class">
        <div className="flex flex-col items-center sm:flex-row sm:justify-center sm:mt-0 first-img sm:mb-0 sm:order-1 order-2 -mb-10">
          <img
            src={firstImage}
            alt="Illustration"
            className="w-[350px] h-[280px] sm:w-[500px] sm:h-[466px] md:w-[575px] md:h-[554px] md:-ml-[6%] sm:ml-0 custom-img"
          />
        </div>
        <div className="w-full sm:w-1/3 text-center sm:text-left sm:-mt-24 main-block mb-0 sm:mb-0 sm:order-2 order-1">
          <h2 className="text-base md:text-lg font-extrabold heading-text">
            <span className="font-extrabold text-[#484647] text-2xl md:text-3xl">
              Home{" "}
            </span>
            <span className="font-extrabold text-[#f16c7d] text-2xl md:text-3xl">
              Fit{" "}
            </span>
            <span className="font-extrabold text-[#484647] text-2xl md:text-3xl">
              Pro.{" "}
            </span>
          </h2>
          <br />
          <p className="text-margin">
            <span className="text-lg md:text-xl mt-2 md:mt-4 max-w-md text-black mx-auto sm:mx-0 font-bold">
              Home Workouts, Pro Results
            </span>
            <br />
            <span className="text-lg md:text-xl mt-2 md:mt-4 max-w-md text-black mx-auto sm:mx-0">
              Transform Your Home into a Fitness Zone!
            </span>
          </p>

          <div className="flex mt-4 justify-center sm:justify-start">
            <div className="inline-block mr-2">
              <a
                href="https://play.google.com/store/apps/details?id=com.sstechsystem.homefitpro"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={googlePlayStore}
                  alt="Google Play Store"
                  className="h-[35px] w-[120px] sm:h-[50px] sm:w-[170px]"
                />
              </a>
            </div>
            <div className="inline-block">
              <a
                href="https://apps.apple.com/us/app/home-fit-pro/id6470997290"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={applerPlayStore}
                  alt="Apple App Store"
                  className="h-[35px] w-[120px] sm:h-[50px] sm:w-[170px]"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @media (max-width: 581px) and (min-width: 388px) {
          .mainbanner-class {
            padding-left: 16px;
            padding-right: 16px;
          }

          .first-img img {
            width: 450px;
            height: 450px;
          }

          .main-block {
            margin-top: -16px;
          }

          .text-margin {
            padding-left: 16px;
            padding-right: 16px;
          }
        }
      `}</style>
    </>
  );
};

export default firstPage;
